/* script */
//
//
//
//
//
//
//
//
//
//
//
//


const __vue_script__ = {
    name: 'EventCard',

    props: {
        event: {
            type: Object,
            required: true
        },

        info: {
            type: Object,
            required: true
        }
    },

    data() {
        const event = this.info.original.origin || {};
        const resource = this.info.currentResource;
        const participants = event.participants || [];

        return {
            calendarEvent: event,
            is_session: this.info.original.is_session,
            participants: [event.organizer, ...participants].filter(Boolean),
            title: this.info.title,
            start: this.info.start,
            end: this.info.end,
            resource,
            status: this.$utils.calendar.computeEventStatus(event, resource),
            STATUS_TO_ICON_CLASS: {
                yes: 'ic-check',
                pending: 'ic-question',
                no: 'ic-x'
            }
        };
    },

    computed: {
        confirmed() {
            if (this.is_session) {
                return null;
            }

            return Object.values(this.calendarEvent.acceptance).filter(a => a === 'yes').length;
        },

        resourceStatus() {
            if (this.is_session) {
                return null;
            }

            return this.calendarEvent.acceptance[this.resource.id];
        },
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"event-card",class:_vm.status},[(_vm.is_session)?_c('div',{staticClass:"badge info solid"},[_vm._v(_vm._s(_vm.$t('meetings.calendar.filters.daily_sessions')))]):_vm._e(),_c('div',{staticClass:"details"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"time"},[_vm._v(_vm._s(_vm.start)+" - "+_vm._s(_vm.end))])]),(_vm.participants.length)?_c('div',{staticClass:"acceptance"},[(_vm.resource.type === 'person')?_c('i',{class:[_vm.resourceStatus, _vm.STATUS_TO_ICON_CLASS[_vm.resourceStatus]]}):_vm._e(),_c('span',{staticClass:"accepted"},[_vm._v(_vm._s(_vm.$t('meetings.calendar.cards.acceptance', [_vm.confirmed, _vm.participants.length])))])]):_vm._e()])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "EventCard.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__